"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getContrastingTextColor = require("../../utils/getContrastingTextColor");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Dialog = {
  styles: function styles(theme) {
    var lastButtonLabelColor = (0, _getContrastingTextColor.getContrastingTextColorHexString)(theme.colors.primary, undefined, undefined, _getContrastingTextColor.PRIMARY_CONTRAST_STANDARD);
    return {
      title: {
        alignItems: "flex-start",
        color: theme.colors.baseContrast070,
        fontSize: theme.typography.fontSize + 2,
        fontWeight: 600,
        letterSpacing: 0.6,
        textTransform: "uppercase",
        marginBottom: theme.spacing.base / 2
      },
      defaultDialogBoxStyles: {
        border: theme.colors.baseContrast050,
        borderRadius: 8,
        backgroundColor: theme.colors.pageBackground,
        padding: theme.spacing.base * 2,
        fontFamily: theme.typography.fontFamily
      },
      svgIcon: {
        width: 18,
        height: 18,
        minHeight: 18,
        minWidth: 18,
        marginTop: 2
      },
      content: {
        fontSize: theme.typography.fontSize,
        fontFamily: theme.typography.fontFamily
      },
      button: {
        borderColor: theme.colors.baseContrast040,
        "&:hover, &:focus-visible": {
          backgroundColor: theme.colors.baseContrast015
        },
        "& label": {
          color: theme.colors.baseContrast070
        },
        "&:last-child > label": {
          color: lastButtonLabelColor
        },
        "&:last-child": {
          background: theme.colors.primary,
          borderColor: theme.colors.primary,
          "&:hover, &:focus-visible": {
            background: theme.colors.primaryDark,
            borderColor: theme.colors.primaryDark,
            "& label": {
              color: lastButtonLabelColor
            }
          }
        }
      },
      small: {
        "& $actions": {
          width: "100%"
        },
        "& $button": {
          width: "100%"
        }
      },
      actions: {
        flexWrap: "wrap"
      }
    };
  }
};
var _default = exports.default = Dialog;